/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ichmchteamabendessenteilnehmen4Inputs */

const en__field_ichmchteamabendessenteilnehmen4 = /** @type {(inputs: _Field_Ichmchteamabendessenteilnehmen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please let us know if you will be attending the dinner for the anniversary celebration of studiumdigitale?`)
};

const de__field_ichmchteamabendessenteilnehmen4 = /** @type {(inputs: _Field_Ichmchteamabendessenteilnehmen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte teilen Sie uns mit, ob Sie beim  Abendessen zur Jubiläumsfeier von studiumdigitale teilnehmen?`)
};

/**
* | output |
* | --- |
* | "Please let us know if you will be attending the dinner for the anniversary celebration of studiumdigitale?" |
*
* @param {_Field_Ichmchteamabendessenteilnehmen4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ichmchteamabendessenteilnehmen4 = /** @type {((inputs?: _Field_Ichmchteamabendessenteilnehmen4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ichmchteamabendessenteilnehmen4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ichmchteamabendessenteilnehmen4(inputs)
	return de__field_ichmchteamabendessenteilnehmen4(inputs)
});
export { _field_ichmchteamabendessenteilnehmen4 as "_field_ichMchteAmAbendessenTeilnehmen" }